import {
  ActivityGraphProvider,
  ActivityGraphTab,
} from './ActivityGraphContext';
import { ActivityGraphTabs } from './ActivityGraphTabs';
import type { SystemEntity } from '@erp/shared-types';

export interface ActivityGraphProps {
  entityType: SystemEntity;
  entityId: string;
  conversationId?: string | null;
  className?: string;
  defaultTab?: ActivityGraphTab;
}

export function ActivityGraph({
  entityType,
  entityId,
  conversationId,
  className,
  defaultTab = 'activity',
}: ActivityGraphProps) {
  return (
    <ActivityGraphProvider defaultTab={defaultTab}>
      <ActivityGraphTabs
        entityType={entityType}
        entityId={entityId}
        conversationId={conversationId}
        className={className}
      />
    </ActivityGraphProvider>
  );
}
